export { CapacitorAdapter } from './capacitor-adapter';

